// extracted by mini-css-extract-plugin
module.exports = {"container":"_2R85HCoLxatslQAV9LwTLK"};